module.exports = __webpack_public_path__ + "static/media/4.e77eb7f9.jpg";